import { SolutionPageTemplate } from "@/components/solutions/SolutionPageTemplate";
import { ShoppingCart, MapPinOff, PackageX, Globe, Map, ShieldCheck, BarChart3 } from "lucide-react";

const challenges = [
  {
    titleKey: "solutionPages.ecommerce.challenges.items.delivery.title",
    descriptionKey: "solutionPages.ecommerce.challenges.items.delivery.description",
    icon: MapPinOff,
  },
  {
    titleKey: "solutionPages.ecommerce.challenges.items.returns.title",
    descriptionKey: "solutionPages.ecommerce.challenges.items.returns.description",
    icon: PackageX,
  },
  {
    titleKey: "solutionPages.ecommerce.challenges.items.expansion.title",
    descriptionKey: "solutionPages.ecommerce.challenges.items.expansion.description",
    icon: Globe,
  },
];

const solutions = [
  {
    titleKey: "solutionPages.ecommerce.solutions.items.zones.title",
    descriptionKey: "solutionPages.ecommerce.solutions.items.zones.description",
    icon: Map,
  },
  {
    titleKey: "solutionPages.ecommerce.solutions.items.validation.title",
    descriptionKey: "solutionPages.ecommerce.solutions.items.validation.description",
    icon: ShieldCheck,
  },
  {
    titleKey: "solutionPages.ecommerce.solutions.items.quality.title",
    descriptionKey: "solutionPages.ecommerce.solutions.items.quality.description",
    icon: BarChart3,
  },
];

const relevantProducts = [
  {
    nameKey: "solutionPages.ecommerce.products.items.atlas.name",
    descriptionKey: "solutionPages.ecommerce.products.items.atlas.description",
    href: "/tjanster/atlas",
    icon: Map,
  },
  {
    nameKey: "solutionPages.ecommerce.products.items.valid.name",
    descriptionKey: "solutionPages.ecommerce.products.items.valid.description",
    href: "/tjanster/valid",
    icon: ShieldCheck,
  },
  {
    nameKey: "solutionPages.ecommerce.products.items.adresstwatt.name",
    descriptionKey: "solutionPages.ecommerce.products.items.adresstwatt.description",
    href: "/tjanster/adresstwatt",
    icon: BarChart3,
  },
];

const heroHighlights = [
  "Validera kundadresser direkt i kassan med Valid",
  "Definiera leveranszoner med postnummerprecision i Atlas",
  "Expandera tryggt till nordiska marknader med korrekt data",
];

const productBullets: Record<string, string[]> = {
  atlas: [
    "Bygg leveranszoner med postnummerytor per region, fraktsätt eller priszon",
    "Visualisera era leveransområden och exportera postnummerlistor",
  ],
  valid: [
    "Integrera autocomplete direkt i er kassa för felfri adressinmatning",
    "Validera adresser i realtid för Sverige, Norge, Danmark och Finland",
  ],
  adresstwatt: [
    "Kvalitetssäkra kundregister inför kampanjer och utskick",
    "Identifiera dubbletter och inaktuella adresser i bulk",
  ],
};

const EcommercePage = () => {
  return (
    <SolutionPageTemplate
      solutionKey="ecommerce"
      heroIcon={ShoppingCart}
      challenges={challenges}
      solutions={solutions}
      relevantProducts={relevantProducts}
      heroHighlights={heroHighlights}
      challengeImpactKey="Felaktiga adresser i e-handeln leder till att upp till 5% av alla leveranser misslyckas – med returer som kostar 3–5 gånger mer än den ursprungliga frakten."
      productBullets={productBullets}
    />
  );
};

export default EcommercePage;
